import { useCentralStore } from "../../store/Central";

export const SUPPORT_PRINT_GRANT_DURATION_MS = 60_000;

let grantedUntil = 0;

export function grantPrintAccess(): number {
	grantedUntil = Date.now() + SUPPORT_PRINT_GRANT_DURATION_MS;
	return grantedUntil;
}

export function revokePrintAccess(): void {
	grantedUntil = 0;
}

export function hasActivePrintGrant(): boolean {
	return Date.now() < grantedUntil;
}

export function getPrintGrantRemainingMs(): number {
	return Math.max(0, grantedUntil - Date.now());
}

export function isSupportAccount(email: string | null | undefined): boolean {
	return !!(email?.includes("support-") && email?.includes("@dentdesk.ch"));
}

export function isPrintAllowedForCurrentUser(): boolean {
	const email = useCentralStore.getState().profile?.email;
	if (!isSupportAccount(email)) return true;
	return hasActivePrintGrant();
}
